import React from 'react';
import styled from 'styled-components';
import { RequiredStar } from '../../styled';
export const LabelWrapper = styled.div `
  font-size: ${(props) => props.theme.fontSmall};
  font-weight: ${(props) => props.theme.semibold};
  line-height: 15px;
  color: ${(props) => props.theme.navyBlue};
  display: inline-block;
  text-align: left;
  margin-bottom: 0.5rem;
  margin-top: 10px;
`;
export const LabelText = styled.span `
  position: static;
`;
const Label = ({ id, requiredStar, text, className }) => (React.createElement(LabelWrapper, { id: id, className: `Label label-wrapper ${className || ''}` },
    requiredStar && React.createElement(RequiredStar, null),
    React.createElement(LabelText, { className: "span-label" }, text)));
Label.defaultProps = {
    requiredStar: false,
};
export default Label;
